import { blueGrey, blue, red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";
const buttonOverrides = {
  MuiButton: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        const isText = !ownerState.variant || ownerState.variant === "text";
        const isOutlined = ownerState.variant === "outlined";
        if (isText && ownerState.color === "primary") {
          return {};
        }
        if (isText && ownerState.color === "secondary") {
          return {};
        }
        if (isOutlined && ownerState.color === "primary") {
          return {
            borderColor: theme.palette.primary.contrastText,
          };
        }
        if (isOutlined && ownerState.color === "secondary") {
          return {
            // color: theme.palette.secondary.contrastText,
            borderColor: theme.palette.secondary.contrastText,
          };
        }
        return {};
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        backgroundImage: "none",
      }),
    },
  },
  MuiPopover: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        backgroundImage: "none",
      }),
    },
  },
};
const theme = (p) => {
  if (p) {
    return createTheme({
      palette: {
        mode: "light",
        secondary: {
          main: p.colorSecundario,
        },
        primary: {
          main: p.colorPrimario,
        },
        error: {
          main: red[400],
        },
      },
      typography: {
        fontFamily: ["Manrope", "Prompt"],
      },
      components: {
        MuiTextField: {
          defaultProps: {
            variant: "standard",
          },
        },
        ...buttonOverrides,
      },
    });
  }
  return createTheme({
    palette: {
      mode: "light",
      secondary: {
        main: blueGrey[900],
      },
      primary: {
        main: blue[500],
        dark: blue[800],
      },
    },
    typography: {
      fontFamily: ["Manrope", "Prompt"],
    },
    components: {
      MuiTextField: {
        defaultProps: {
          variant: "standard",
        },
      },
      ...buttonOverrides,
    },
  });
};

export default theme;
